import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const Navigation: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed inset-x-0 top-0 z-50">
      <div className="mx-auto max-w-6xl px-4 pt-4 sm:px-6">
        <div className="glass-panel flex min-h-[76px] items-center justify-between rounded-[28px] px-4 sm:px-5">
          <Link to="/" onClick={closeMenu} className="flex items-center gap-3 py-3">
            <img src="/vizo-logo.png" alt="Vizo" className="h-11 w-11 rounded-xl" />
            <div className="flex flex-col">
              <span className="font-display text-base font-semibold tracking-tight text-white">Vizo</span>
              <span className="text-sm text-slate-400">Music Visualizer</span>
            </div>
          </Link>
          <button
            className="inline-flex h-11 w-11 items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-white transition hover:border-white/20 hover:bg-white/10 md:hidden"
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
          >
            <span className="sr-only">Menu</span>
            <div className="space-y-1.5">
              <span className={`block h-0.5 w-5 rounded bg-white transition ${isMenuOpen ? 'translate-y-2 rotate-45' : ''}`}></span>
              <span className={`block h-0.5 w-5 rounded bg-white transition ${isMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`block h-0.5 w-5 rounded bg-white transition ${isMenuOpen ? '-translate-y-2 -rotate-45' : ''}`}></span>
            </div>
          </button>
          <ul className="hidden items-center gap-2 md:flex">
            {[
              { to: '/', label: 'Home' },
              { to: '/support', label: 'Support' },
              { to: '/privacy', label: 'Privacy' }
            ].map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  onClick={closeMenu}
                  className={({ isActive }) =>
                    `inline-flex rounded-full px-4 py-2 text-sm font-medium transition ${
                      isActive
                        ? 'bg-white/10 text-white'
                        : 'text-slate-400 hover:bg-white/5 hover:text-white'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
            <li className="ml-1">
              <a
                href="https://apps.apple.com/tr/app/unvis-music-visualizer/id6749325448"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center rounded-full bg-gradient-to-r from-brand-500 to-cyanGlow px-4 py-2 text-sm font-semibold text-white shadow-glow transition hover:-translate-y-0.5"
                onClick={closeMenu}
              >
                Download
              </a>
            </li>
          </ul>
        </div>
        <ul className={`${isMenuOpen ? 'flex' : 'hidden'} glass-panel absolute left-4 right-4 top-[92px] flex-col gap-3 rounded-[28px] p-5 shadow-2xl md:hidden`}>
          <li>
            <NavLink
              to="/"
              onClick={closeMenu}
              className={({ isActive }) =>
                `inline-flex rounded-full px-4 py-3 text-sm font-medium transition ${
                  isActive
                    ? 'bg-white/10 text-white'
                    : 'text-slate-400 hover:bg-white/5 hover:text-white'
                }`
              }
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/support"
              onClick={closeMenu}
              className={({ isActive }) =>
                `inline-flex rounded-full px-4 py-3 text-sm font-medium transition ${
                  isActive
                    ? 'bg-white/10 text-white'
                    : 'text-slate-400 hover:bg-white/5 hover:text-white'
                }`
              }
            >
              Support
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/privacy"
              onClick={closeMenu}
              className={({ isActive }) =>
                `inline-flex rounded-full px-4 py-3 text-sm font-medium transition ${
                  isActive
                    ? 'bg-white/10 text-white'
                    : 'text-slate-400 hover:bg-white/5 hover:text-white'
                }`
              }
            >
              Privacy
            </NavLink>
          </li>
          <li>
            <a
              href="https://apps.apple.com/tr/app/unvis-music-visualizer/id6749325448"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center rounded-full bg-gradient-to-r from-brand-500 to-cyanGlow px-4 py-3 text-sm font-semibold text-white shadow-glow transition hover:-translate-y-0.5"
              onClick={closeMenu}
            >
              Download
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
